// extracted by mini-css-extract-plugin
export default {"wrapper":"TeamsOfService_wrapper_kfz5b"};